<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model.trim="keyword" :placeholder="keyWordMsg" style="width: 240px" @keyup.enter.native="sendEvent">
            <ElSelect v-model="type" slot="prepend" style="width: 88px">
              <ElOption :value="1" label="素材名称"></ElOption>
              <ElOption :value="2" label="任务ID"></ElOption>
            </ElSelect>
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="taskTypes" multiple collapse-tags filterable clearable placeholder="选择类型">
            <el-option v-for="item in taskTypeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="gameIds" multiple collapse-tags filterable clearable placeholder="选择游戏">
            <el-option v-for="item in gameData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="multiTaskStatus" multiple collapse-tags filterable clearable placeholder="选择状态">
            <el-option v-for="item in statusList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="opIds" multiple collapse-tags filterable clearable placeholder="选择创建人">
            <el-option v-for="item in operatorData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
          <ElButton type="primary" @click="$router.push({ name: 'shutdownadd' })">新增任务</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
const statusList = [
  { name: '进行中', id: 1 },
  { name: '已完成', id: 2 },
  { name: '未开始', id: 0 }
]
export default {
  name: 'listFilter',
  props: {
    operatorData: {
      type: Array
    },
    gameData: {
      type: Array
    }
  },
  methods: {
    sendEvent() {
      const params = {
        keyword: this.keyword,
        opIds: this.opIds,
        multiTaskStatus: this.multiTaskStatus,
        taskTypes: this.taskTypes,
        gameIds: this.gameIds,
        type: this.keyword === '' ? undefined : this.type
      }
      this.$emit('on-change', params)
    },
    handleAgent(meta) {
      this.agentId = meta.id
    },
    handleGame(meta) {
      this.gameId = meta.id
    }
  },
  computed: {
    keyWordMsg() {
      const msg = this.type === 1 ? '素材名称' : '任务ID'
      return `请输入${msg}`
    }
  },
  watch: {},
  data() {
    return {
      keyword: '',
      taskTypes: [],
      gameIds: [],
      opIds: [],
      multiTaskStatus: [],
      taskTypeList: [
        { id: 0, name: '一键素材关停' },
        { id: 1, name: '一键计划关停' }
      ],
      statusList,
      type: 1
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>
<style scoped lang="scss">
.c-filter {
  ::v-deep .ivu-input-group-prepend {
    border: 0;
    padding: 0;
  }
  ::v-deep .ivu-input-group-append {
    border: 0;
  }
}
</style>
